//import React from 'react'
import { Button, Col, Container, Nav, Row } from "react-bootstrap";
import { Outlet, useLocation, useNavigate } from "react-router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useDispatch, useSelector } from "react-redux";

import HeaderLeft from "./components/HeaderLeft";
import Footer from "./components/Footer";

import { Suspense, useEffect, useState } from "react";
import HeaderTop from "./components/HeaderTop";
import MobileBottomMenuScreen from "./screens/MobileBottomMenuScreen";
import TopSubMenu from "./components/TopSubMenu";
import RazorpayPayButton from "./components/RazorpayPayButton";
import Loader from "./components/Loader";
import ChunkErrorBoundary from "./components/ChunkErrorBoundary";
import AppUpdateBanner from "./components/AppUpdateBanner";
import { getDateOfLast, getCurrentDate } from "./utils/getCurrentDate";
import { setCredentials } from "./slices/authSlice";
import { useGetMemberWiseAnalyticsQuery } from "./slices/dashBoardSlice";

const App = () => {
  // ENABLE THIS CODE FOR AUTO LOGOFF
  const { userInfo } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  // setTimeout(() => {
  //   console.log("currTime - loginTime");
  //   console.log(
  //     new Date(getCurrentDate() + getCurrentTime()) -
  //       new Date(userInfo?.loginDate)
  //   );

  //   if (
  //     userInfo !== null &&
  //     (new Date(getCurrentDate() + getCurrentTime()) -
  //       new Date(userInfo?.loginDate)) /
  //       1000 >
  //       86400
  //   ) {
  //     console.log("clearing redux after 60 minutes");
  //     dispatch(logout());
  //   }
  // }, 60000);

  const [mobileScreen, setMobileScreen] = useState(window.innerWidth < 600);

  const today = new Date().toISOString().split("T")[0];

  const shouldFetchAnalytics =
    !userInfo?.lastRetrieved_userAnalytics ||
    userInfo.lastRetrieved_userAnalytics.split("T")[0] !== today;

  const {
    data: analyticsData,
    isLoading: analyticsDataLoading,
    error: analyticsDataError,
    refetch,
  } = useGetMemberWiseAnalyticsQuery(
    { token: userInfo?.token },
    {
      skip: !shouldFetchAnalytics,
    }
  );

  useEffect(() => {
    if (analyticsData?.data && userInfo?.allUsers?.length) {
      const updatedAnalytics = analyticsData.data.map((member) => ({
        ...member,
      }));

      const analyticsMap = {};

      updatedAnalytics.forEach((member) => {
        analyticsMap[member.userId] = member;
      });

      updatedAnalytics.forEach((member) => {
        const user = userInfo?.allUsers?.find(
          (u) => String(u.userId) === String(member.userId)
        );

        if (user?.joinedDate) {
          const joinedDate = new Date(user.joinedDate);
          const today = new Date();

          let months =
            (today.getFullYear() - joinedDate.getFullYear()) * 12 +
            (today.getMonth() - joinedDate.getMonth());

          if (today.getDate() < joinedDate.getDate()) {
            months--;
          }

          if (months <= 0) months = 1;

          member.amountPaidPerMonth = Number(
            (member.totalAmountPaidTillNow / months).toFixed(2)
          );

          member.joinedDate = user.joinedDate;
          member.firstName = user.firstName;
          member.lastName = user.lastName;
          member._id = user._id;
          member.imageUploadedTime = user.imageUploadedTime;
        } else {
          member.amountPaidPerMonth = 0;
        }
      });

      [...updatedAnalytics]
        .sort(
          (a, b) =>
            (b.totalAmountPaidTillNow || 0) - (a.totalAmountPaidTillNow || 0)
        )
        .forEach((member, index) => {
          analyticsMap[member.userId].totalPaidRank = index + 1;
        });

      [...updatedAnalytics]
        .sort(
          (a, b) => (b.amountPaidPerMonth || 0) - (a.amountPaidPerMonth || 0)
        )
        .forEach((member, index) => {
          analyticsMap[member.userId].perMonthAmountRank = index + 1;
        });

      [...updatedAnalytics]
        .sort(
          (a, b) =>
            (b.actualAttendanceDays || 0) - (a.actualAttendanceDays || 0)
        )
        .forEach((member, index) => {
          analyticsMap[member.userId].attendanceDaysRank = index + 1;
        });

      [...updatedAnalytics]
        .sort(
          (a, b) =>
            (b.activeMembershipPercentage || 0) -
            (a.activeMembershipPercentage || 0)
        )
        .forEach((member, index) => {
          analyticsMap[member.userId].activeMembershipRank = index + 1;
        });

      dispatch(
        setCredentials({
          ...userInfo,
          userAnalytics: {
            ...analyticsData,
            data: updatedAnalytics,
          },
          lastRetrieved_userAnalytics: new Date().toISOString(),
        })
      );
    }
  }, [analyticsData, userInfo?.allUsers]);



  useEffect(() => {
    const handleResize = () => {
      setMobileScreen(window.innerWidth < 600);
      // console.log("Mobile Screen");
      // console.log(window.innerWidth);
      // console.log(window.innerWidth < 600);
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [expandMenu, setExpandMenu] = useState(true);
  const headerBgColor = userInfo?.gymId?.themeColors?.headerBg || "#0A5A6A";
  const headerTextColor = userInfo?.gymId?.themeColors?.headerText || "#FFFFFF";
  const bodyBgColor = userInfo?.gymId?.themeColors?.bodyBg || "#fdffff";
  const bodyTextColor = userInfo?.gymId?.themeColors?.bodyText || "#374E3D";
  const selectedFontFamily =
    userInfo?.gymId?.themeColors?.fontFamily ||
    'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"';

  document.documentElement.style.setProperty("--bs-primary", headerBgColor);
  document.documentElement.style.setProperty("--bs-btn-color", headerTextColor);
  document.documentElement.style.setProperty("--bs-body-bg", bodyBgColor);
  document.documentElement.style.setProperty("--bs-gray", bodyTextColor);
  document.documentElement.style.setProperty(
    "--bs-font-sans-serif",
    selectedFontFamily
  );
  const navigate = useNavigate();

  const gotoGymProfile = async () => {
    navigate("/gymProfile");
  };
  const { pathname } = useLocation();

  return (
    <div
      className={`${userInfo?.themeColor}Theme`}
      style={{
        backgroundColor: bodyBgColor,
        background: !userInfo
          ? `
  radial-gradient(
    ellipse at 15% 10%,
    rgba(4, 51, 51, 0.16) 0%,
    transparent 35%
  ),
  radial-gradient(
    ellipse at 90% 90%,
    rgba(3, 81, 87, 0.2) 0%,
    transparent 40%
  ),
  linear-gradient(
    160deg,
    #001013 0%,
    #03363d 35%,
    #31a8b3 90%,
    #89eff6 100%
  )
`
          : bodyBgColor,
      }}
    >
      <ToastContainer position="top-center" autoClose="3000" />
      {mobileScreen && userInfo?.associateId && <HeaderTop></HeaderTop>}
      {userInfo?.associateId && !mobileScreen && (
        <HeaderLeft leftMenuOpen={expandMenu} setExpandMenu={setExpandMenu} />
      )}
      {userInfo?.associateId && !mobileScreen && <TopSubMenu />}
      {/* Renders nothing on the web and whenever no update is pending. */}
      <AppUpdateBanner />
      <main
        className="py-2"
        style={{
          marginLeft:
            mobileScreen || !userInfo ? "0px" : expandMenu ? "16rem" : "3rem",
          // height: "100vh",
          backgroundAttachment: "fixed",
          // overflow: "scroll",
          // backgroundColor: bodyBgColor,
          // backgroundImage: `url(${bgImage})`, // Corrected: Use backticks and template literal to reference the variable
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          marginBottom: "5rem",
        }}
      >
        {((new Date(userInfo?.gymId?.subsExpiryDate) <
          new Date(getDateOfLast(-15)) &&
          userInfo?.gymId?.paymentCycle === "Yearly") ||
          (new Date(userInfo?.gymId?.subsExpiryDate) <
            new Date(getDateOfLast(-15)) &&
            userInfo?.gymId?.paymentCycle === "Halfyearly") ||
          (new Date(userInfo?.gymId?.subsExpiryDate) <
            new Date(getDateOfLast(-10)) &&
            userInfo?.gymId?.paymentCycle === "Quarterly") ||
          (new Date(userInfo?.gymId?.subsExpiryDate) <
            new Date(getDateOfLast(-3)) &&
            userInfo?.gymId?.paymentCycle === "Monthly")) && (
          <Row
            style={{
              color: "red",

              marginLeft: "1.5rem",
            }}
          >
            {" "}
            <Row style={{ justifyContent: "center", alignItems: "center" }}>
              <Col
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {new Date(userInfo?.gymId?.subsExpiryDate) < new Date() ? (
                  <span style={{ textAlign: "center", color: "red" }}>
                    Your subscription has expired on{" "}
                    {userInfo?.gymId?.subsExpiryDate?.split("T")[0]}. Contact -
                    7806873973
                  </span>
                ) : (
                  <span style={{ textAlign: "center", color: "red" }}>
                    Your subscription will expire on{" "}
                    {userInfo?.gymId?.subsExpiryDate?.split("T")[0]}
                  </span>
                )}
              </Col>
            </Row>
            {pathname !== "/gymProfile" && !userInfo?.isMobileScreen && (
              <Row style={{ justifyContent: "center", alignItems: "center" }}>
                <Col
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Button
                    size="sm"
                    onClick={gotoGymProfile}
                    style={{ marginLeft: "0.75rem" }}
                  >
                    Click to Pay Now
                  </Button>
                </Col>
              </Row>
            )}
            <br />
            <br />
            <br />
          </Row>
        )}
        {userInfo?.gymId?.subscriptionType === "Free" && (
          <span
            style={{
              color: "green",
              marginLeft: "1.5rem",
              fontSize: "0.9rem",
            }}
          >
            Your Free subscription is valid till{" "}
            {userInfo?.gymId?.subsExpiryDate?.split("T")[0]}.
          </span>
        )}
        {/* {userInfo?.gymId?.subscriptionType !== "Free" &&
          new Date(userInfo?.gymId?.subsExpiryDate) <=
            new Date(new Date().setDate(new Date().getDate() + 15)) &&
          new Date(userInfo?.gymId?.subsExpiryDate) > new Date() && (
            <span
              style={{
                color: "green",
                marginLeft: "1.5rem",
                fontSize: "0.9rem",
              }}
            >
              Your subscription will expire soon on{" "}
              {userInfo?.gymId?.subsExpiryDate?.split("T")[0]}. Please renew
            </span>
          )} */}
        {userInfo?.associateId &&
          new Date(getCurrentDate()) <= new Date("2026-08-11") && (
            <Nav.Link
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "blue",
                whiteSpace: "nowrap",
                margin: "1rem",
                fontSize: "1.2rem",
                textDecoration: "underline",
              }}
              href="https://youtu.be/TbPvys0jYXk"
              target="_blank"
              rel="noopener noreferrer"
            >
              <strong>Member App Available - click</strong>
            </Nav.Link>
          )}

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "20px",
            marginLeft: "1.5rem",
            flexWrap: "wrap",
          }}
        >
          {/* {new Date(userInfo?.gymId?.subsExpiryDate) >= new Date() &&
            userInfo?.gymId?.dueAmount > 0 && (
              <span
                style={{
                  color: "green",
                  fontSize: "0.9rem",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                You have pending amount of ₹{userInfo.gymId?.dueAmount}. Please
                make the payment soon.
                <RazorpayPayButton
                  gym={userInfo?.gymId}
                  token={userInfo?.token}
                  associateId={userInfo?.associateId}
                  onSuccess={() => window.location.reload()}
                  label="Click to Pay Now"
                  size="sm"
                  style={{ marginLeft: "0.75rem" }}
                  variant="warning"
                />
              </span>
            )} */}
        </div>

        <Container>
          {/* Outside Suspense: a rejected lazy import surfaces as a render
              error, which only a boundary ABOVE the Suspense can catch.
              resetKey (not key) clears the error on navigation without
              remounting the subtree on every route change. */}
          <ChunkErrorBoundary resetKey={pathname}>
            <Suspense fallback={<Loader />}>
              <Outlet
                key={`${userInfo?.gymId?._id || "guest"}-${
                  userInfo?.associateId || ""
                }`}
              />
            </Suspense>
          </ChunkErrorBoundary>
        </Container>
      </main>
      {mobileScreen && <MobileBottomMenuScreen />}
      {!mobileScreen && <Footer />}
    </div>
  );
};

export default App;
